var page_schema = {
    "tiers": [
        {
            "name": "Sample Types",
            "type": "checkbox",
            "id": "applications_dropdown",
            "class_name": "tags",
            "child_name": "application",
            // "collapsable": true,
            "options": [
                {
                    "name": "Blood",
                    "id": "blood"
                },
                {
                    "name": "Environmental / Vector",
                    "id": "environmental-vector"
                },
                {
                    "name": "Feces",
                    "id": "feces"
                },
                {
                    "name": "Mouth, Nose and Throat",
                    "id": "mouth-nose-and-throat"
                },
                {
                    "name": "Saliva",
                    "id": "saliva"
                },
                {
                    "name": "Skin",
                    "id": "skin"
                },
                {
                    "name": "Tissue",
                    "id": "tissue"
                },
                {
                    "name": "Urine",
                    "id": "urine"
                },
                {
                    "name": "Vaginal",
                    "id": "vaginal"
                },
                {
                    "name": "Wound",
                    "id": "wound"
                },
                {
                  "name": "Water",
                  "id": "water",
                },
                {
                  "name": "Environmental",
                  "id": "environmental",
                },
                {
                  "name": "Soil & Sludge",
                  "id": "soil-and-sludge",
                },
                {
                  "name": "NGS Library",
                  "id": "ngs-library",
                },
            ]
        },
        {
            "name": "Features",
            "type": "checkbox",
            "id": "features",
            "class_name": "tags",
            "child_name": "feature",
            // "collapsable": false,
            "options": [
                {
                    "name": "CE-IVD",
                    "id": "ce-ivd-certified"
                },
            ]
        },
        {
            "name": "Format",
            "type": "checkbox",
            "id": "format",
            "class_name": "tags",
            "child_name": "feature",
            "options": [
                {
                    "name": "Reagent",
                    "id": "reagent"
                },
                {
                    "name": "Device",
                    "id": "device"
                }
            ]
        },
    ],
    "filters": [],
    "products": {
        "DNA/RNA Shield": {
            "title": "DNA/RNA Shield",
            "catalogNumbers": "R1100-50, R1100-250, R1200-25, R1200-125",
            "description": "DNA/RNA Shield reagent is a nucleic acid transport and storage medium for any sample. Free sample available for validation with free shipping.",
            "handle": "/collections/dna-rna-shield/products/dna-rna-shield",
            "image_url": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R1100-50-DNA-RNA-Shield-Reagent-50ml.png?v=1628532369&width=200",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R1100-50-DNA-RNA-Shield-Reagent-50ml.png?v=1628532369&width=600",
            "generalIndex": 1,
            "tags": [
                "blood",
                "environmental-vector",
                "feces",
                "skin",
                "wound",
                "vaginal",
                "mouth-nose-and-throat",
                "saliva",
                "tissue",
                "free-sample",
                "soil-and-sludge",
                "water",
                "environmental",
                "urine",
                "reagent"
            ],
            filters: []
        },
        "DNA/RNA Shield Blood Collection Tube": {
            "title": "DNA/RNA Shield Blood Collection Tube",
            "catalogNumbers": "R1150",
            "description": "Tubes designed for the collection and transportation of whole blood at ambient temperatures. Instantly stabilize DNA and RNA while inactivating pathogenic organisms.",
            "handle": "/collections/blood-collection/products/dna-rna-shield-blood-collection-tube",
            "image_url": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R1150-DNA-RNA-Shield-Blood-Collection-Tube_67c40b0d-dd64-4215-9976-fcae0bb8bf19.jpg?v=1628532357&width=200",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R1150-DNA-RNA-Shield-Blood-Collection-Tube_67c40b0d-dd64-4215-9976-fcae0bb8bf19.jpg?v=1628532357&width=600",
            "generalIndex": 2,
            "tags": [
                "blood",
                "6-ml",
                "free-sample",
                "device"
            ],
            filters: []
        },
        "DNA/RNA Shield Collection Tube with Swab": {
            "title": "DNA/RNA Shield Collection Tube with Swab",
            "catalogNumbers": "R1106, R1107, R1108, R1109, R1107-E, R1109-E",
            "description": "A general purpose swab collection method for molecular-based applications. Samples are stabilized in DNA/RNA Shield and ready for transport or storage.",
            "handle": "/collections/vector-and-environmental-collection/products/dna-rna-shield-collection-tube-w-swab",
            "image_url": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R1106_DNA-RNA-Shield-Swab-Tube.png?v=1628532361&width=200",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R1106_DNA-RNA-Shield-Swab-Tube.png?v=1628532361&width=600",
            "generalIndex": 8,
            "tags": [
                "environmental-vector",
                "feces",
                "skin",
                "wound",
                "vaginal",
                "mouth-nose-and-throat",
                "saliva",
                "1-ml",
                "2-ml",
                "free-sample",
                "soil-and-sludge",
                "water",
                "environmental",
                "ce-ivd-certified",
                "device"
            ],
            filters: []
        },
        "DNA/RNA Shield Lysis & Collection Tubes": {
            "title": "DNA/RNA Shield Lysis & Collection Tubes",
            "catalogNumbers": "R1103, R1104, R1105, R1102",
            "description": "Lysis tubes filled with DNA/RNA Shield and a lysis matrix for the streamlined collection, transport, and processing of biological specimens such as tissue and microbial samples.",
            "handle": "/collections/vector-and-environmental-collection/products/dna-rna-shield-lysis-and-collection-tubes",
            "image_url": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R1103-DNA-RNA-Shield-Lysis-Tube-_Microbe.jpg?v=1628532366&width=200",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R1103-DNA-RNA-Shield-Lysis-Tube-_Microbe.jpg?v=1628532366&width=600",
            "generalIndex": 7,
            "tags": [
                "environmental-vector",
                "feces",
                "tissue",
                "1-ml",
                "free-sample",
                "soil-and-sludge",
                "water",
                "environmental",
                "device"
            ],
            filters: []
        },
        "DNA/RNA Shield Fecal Collection Tube": {
            "title": "DNA/RNA Shield Fecal Collection Tube",
            "catalogNumbers": "R1101, R1137",
            "description": "Collection tubes for stool specimen preservation while inactivating pathogens. Nucleic acids are stabilized in DNA/RNA Shield and ready for transport or storage.",
            "handle": "/collections/vector-and-environmental-collection/products/dna-rna-shield-fecal-collection-tube",
            "image_url": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R1101-5-4_DNA-RNA-Shield-Fecal-Collection-Tube-with-Beads__1_2b1bc116-845c-43f8-8fd5-9b42ae95d9fa.jpg?v=1657578907&width=200",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R1101-5-4_DNA-RNA-Shield-Fecal-Collection-Tube-with-Beads__1_2b1bc116-845c-43f8-8fd5-9b42ae95d9fa.jpg?v=1657578907&width=600",
            "generalIndex": 3,
            "tags": [
                "feces",
                "soil-and-sludge",
                "4-ml",
                "9-ml",
                "free-sample",
                "device"
            ],
            filters: []
        },
        "ZR BashingBead Lysis Tubes (2 mm)": {
            "title": "ZR BashingBead Lysis Tubes (2 mm)",
            "catalogNumbers": "S6003-50",
            "description": "2mL tubes containing ultra-high density 2mm BashingBeads that are fracture resistant, chemically inert, and ideal for disrupting tough-to-lyse biological samples.",
            "handle": "/collections/vector-and-environmental-collection/products/zr-bashing-bead-lysis-tubes",
            "image_url": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/S6003-ZR-BashingBead-Lysis-Tubes-2.0-mm.jpg?v=1628532404&width=200",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/S6003-ZR-BashingBead-Lysis-Tubes-2.0-mm.jpg?v=1628532404&width=600",
            "generalIndex": 999,
            "tags": [
                "environmental-vector",
                "tissue",
                "accessories",
                "water",
                "environmental",
                "device"
            ],
            filters: []
        },
        "ZR BashingBead Lysis Tubes (0.1 & 0.5 mm)": {
            "title": "ZR BashingBead Lysis Tubes (0.1 & 0.5 mm)",
            "catalogNumbers": "S6012-50",
            "description": "2mL tubes containing ultra-high density 0.1 and 0.5mm BashingBeads that are fracture resistant, chemically inert, and ideal for disrupting tough-to-lyse biological samples.",
            "handle": "/collections/vector-and-environmental-collection/products/zr-bashingbead-lysis-tubes-0-1-0-5-mm",
            "image_url": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/S6012-50_ZR-BashingBead-Lysis-Tubes.png?v=1628532396&width=200",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/S6012-50_ZR-BashingBead-Lysis-Tubes.png?v=1628532396&width=600",
            "generalIndex": 999,
            "tags": [
                "environmental-vector",
                "feces",
                "skin",
                "wound",
                "vaginal",
                "accessories",
                "tissue",
                "soil-and-sludge",
                "water",
                "environmental",
                "device"
            ],
            filters: []
        },
        "ZR BashingBead Lysis Tubes (0.1 & 2.0 mm)": {
            "title": "ZR BashingBead Lysis Tubes (0.1 & 2.0 mm)",
            "catalogNumbers": "S6014-50",
            "description": "2mL tubes containing ultra-high density 0.1 and 2.0mm BashingBeads that are fracture resistant, chemically inert, and ideal for disrupting tough-to-lyse biological samples.",
            "handle": "/collections/vector-and-environmental-collection/products/zr-bashingbead-lysis-tubes-0-1-2-0-mm",
            "image_url": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/zr_bashingbead_lysis_tubes_2.0_mm_s6003-50__1.png?v=1628532407&width=200",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/zr_bashingbead_lysis_tubes_2.0_mm_s6003-50__1.png?v=1628532407&width=600",
            "generalIndex": 999,
            "tags": [
                "environmental-vector",
                "feces",
                "tissue",
                "accessories",
                "soil-and-sludge",
                "water",
                "environmental",
                "device"
            ],
            filters: []
        },
        "ZR BashingBead Lysis/Filtration Tubes": {
            "title": "ZR BashingBead Lysis/Filtration Tubes",
            "catalogNumbers": "S6010, S6011",
            "description": "50 ml conical tube containing ultra-high density 0.5mm or 2.0mm BashingBeads that are fracture resistant, chemically inert, and ideal for disrupting tissues or microbes",
            "handle": "/collections/vector-and-environmental-collection/products/zr-bashingbead-lysis-filtration-tubes",
            "image_url": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/S6010_ZR-BashingBead-Lysis-Filtration-Tube---50-mL.jpg?v=1628532394&width=200",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/S6010_ZR-BashingBead-Lysis-Filtration-Tube---50-mL.jpg?v=1628532394&width=600",
            "generalIndex": 999,
            "tags": [
                "environmental-vector",
                "feces",
                "tissue",
                "accessories",
                "soil-and-sludge",
                "water",
                "environmental",
                "device"
            ],
            filters: []
        },
        "DNA/RNA Shield Fecal Collection Kit": {
            "title": "DNA/RNA Shield Fecal Collection Kit",
            "catalogNumbers": "R1180",
            "description": "The Individual Fecal Collection Kit is a conveniently pouched kit that includes all the components needed for collecting and stabilizing fecal samples.",
            "handle": "/products/dna-rna-shield-fecal-collection-kit",
            "image_url": "https://files.zymoresearch.com/product-images/r1180_dna_rna_shield_fecal_collection_kit.jpg",
            "navigation_image": "https://files.zymoresearch.com/product-images/r1180_dna_rna_shield_fecal_collection_kit.jpg",
            "generalIndex": 4,
            "tags": [
                "feces",
                "free-sample",
                "device"
            ],
            filters: []
        },
        "DNA/RNA Shield Fecal Collection Tube - DX": {
            "title": "DNA/RNA Shield Fecal Collection Tube - DX",
            "catalogNumbers": "R1101-E",
            "description": "Clinical fecal receptacle device for molecular-based in vitro diagnostic applications. Take a microbial snapshot of a sample while inactivating viruses for safe transport and storage.",
            "handle": "/collections/fecal-collection/products/dna-rna-shield-fecal-collection-tube-dx",
            "image_url": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R1101-E_DNA-RNA-Shield-Fecal-Collection-Tube-DX.jpg?v=1657578772&width=200",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R1101-E_DNA-RNA-Shield-Fecal-Collection-Tube-DX.jpg?v=1657578772&width=600",
            "generalIndex": 11,
            "tags": [
                "feces",
                "ce-ivd-certified",
                "9-ml",
                "device"
            ],
            filters: []
        },
        "DNA/RNA Shield SafeCollect Swab Collection Kit": {
            "title": "DNA/RNA Shield SafeCollect Swab Collection Kit",
            "catalogNumbers": "R1160-E, R1161-E, R1160, R1161",
            "description": "Collection kit for stabilizing nucleic acids in samples collected with a swab. Designed to eliminate the risk of spilling and is ideal for at-home self collection. ",
            "handle": "/collections/fecal-collection/products/dna-rna-shield-safecollect-swab-collection-kit",
            "image_url": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/r1160-dna_rna_shield_safecollect_swab_collection_kit_9b3615c8-4774-4473-833b-ace482e1b807.jpg?v=1631056448&width=200",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/r1160-dna_rna_shield_safecollect_swab_collection_kit_9b3615c8-4774-4473-833b-ace482e1b807.jpg?v=1631056448&width=600",
            "generalIndex": 9,
            "tags": [
                "environmental-vector",
                "feces",
                "skin",
                "wound",
                "vaginal",
                "mouth-nose-and-throat",
                "saliva",
                "ce-ivd-certified",
                "1-ml",
                "2-ml",
                "free-sample",
                "soil-and-sludge",
                "water",
                "environmental",
                "device"
            ],
            filters: []
        },
        "Bunny Wipe Fecal Sample Collector": {
            "title": "Bunny Wipe Fecal Sample Collector",
            "catalogNumbers": "R1133-1, R1133-10, R1138, R1101",
            "description": "A fecal collection device that mimics toilet paper to provide comfortable, user-friendly collection. Samples are stabilized in pre-filled DNA/RNA Shield and ready for transport or storage.",
            "handle": "/collections/fecal-collection/products/bunny-wipe-fecal-sample-collector",
            "image_url": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/Wipe___Tube.jpg?v=1668065284&width=200",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/Wipe___Tube.jpg?v=1668065284&width=600",
            "generalIndex": 6,
            "tags": [
                "feces",
                "9-ml",
                "accessories",
                "free-sample",
                "device"
            ],
            filters: []
        },
        "Feces Catcher": {
            "title": "Feces Catcher",
            "catalogNumbers": "R1101-1-10",
            "description": "A hygienic, flushable strip of fecal collection paper that fits onto any toilet seat for easy fecal collection",
            "handle": "/collections/fecal-collection/products/feces-catcher",
            "image_url": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R1101-1-10_Feces-Catcher.jpg?v=1671135398&width=200",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R1101-1-10_Feces-Catcher.jpg?v=1671135398&width=600",
            "generalIndex": 999,
            "tags": [
                "feces",
                "accessories",
                "device"
            ],
            filters: []
        },
        "ColOff (Stool Collection Device)": {
            "title": "ColOff (Stool Collection Device)",
            "catalogNumbers": "R1101-2-5",
            "description": "A hygienic, disposable, easy-to-use stool collection facilitation device. It is a plastic sleeve that facilitates stool collection in a physiological position (sitting on the toilet seat).",
            "handle": "/collections/fecal-collection/products/coloff-stool-collection-device",
            "image_url": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R1101-2-5_Coloff-Stool-Collection-Device.jpg?v=1671135003&width=200",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R1101-2-5_Coloff-Stool-Collection-Device.jpg?v=1671135003&width=600",
            "generalIndex": 999,
            "tags": [
                "feces",
                "accessories",
                "device"
            ],
            filters: []
        },
        "DNA/RNA Shield SafeCollect Saliva Collection Kit": {
            "title": "DNA/RNA Shield SafeCollect Saliva Collection Kit",
            "catalogNumbers": "R1211-E, R1211",
            "description": "A user-friendly, spill-free saliva/sputum collection kit that stabilizes nucleic acid and inactivates pathogens. Ideal for applications that require at-home self collection. ",
            "handle": "/collections/saliva-collection/products/dna-rna-shield-safecollect-saliva-collection-kit",
            "image_url": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/r1211-dna_rna_shield_safecollect_saliva_collection_kit.jpg?v=1631056521&width=200",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/r1211-dna_rna_shield_safecollect_saliva_collection_kit.jpg?v=1631056521&width=600",
            "generalIndex": 5,
            "tags": [
                "saliva",
                "ce-ivd-certified",
                "2-ml",
                "free-sample",
                "device"
            ],
            filters: []
        },
        "Sterile Collection Swab": {
            "title": "Sterile Collection Swab",
            "catalogNumbers": "C1052-50, C1053-50",
            "description": "Individually packaged sterile fiber swabs for the collection of samples from the mouth, nose, and throat for research and pre-analytical diagnostic use. 20mm Break Point",
            "handle": "/collections/swab-collection/products/sterile-collection-swab",
            "image_url": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1052-50_Zymo_20Collection_20Swab_20-_2020_20mm_20Break_20Point.png?v=1628532409&width=200",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/C1052-50_Zymo_20Collection_20Swab_20-_2020_20mm_20Break_20Point.png?v=1628532409&width=600",
            "generalIndex": 999,
            "tags": [
                "environmental-vector",
                "feces",
                "skin",
                "wound",
                "vaginal",
                "mouth-nose-and-throat",
                "saliva",
                "accessories",
                "soil-and-sludge",
                "water",
                "environmental",
                "device"
            ],
            filters: []
        },
        "Urine Collection Kit": {
            "title": "Urine Collection Kit",
            "catalogNumbers": "D3062",
            "description": "Urine collection kit with Urine Conditioning Buffer (UCB), which preserves DNA and RNA during sample storage and transport at ambient temperatures.",
            "handle": "/collections/urine-collection/products/urine-collection-kit",
            "image_url": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D3062_Urine-Collection-Kit-with-Urine-Conditioning-Buffer_f6f71bce-ab5a-4d9e-a73e-023fa42fe726.png?v=1628532353&width=200",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D3062_Urine-Collection-Kit-with-Urine-Conditioning-Buffer_f6f71bce-ab5a-4d9e-a73e-023fa42fe726.png?v=1628532353&width=600",
            "generalIndex": 11,
            "tags": [
                "urine",
                "device"
            ],
            filters: []
        },
        "Wee Box": {
            "title": "Wee Box",
            "catalogNumbers": "C1107",
            "description": "Wee Box is a flat, paper-based, collapsible urine collector designed to make specimen self-collection simple, hygienic, and mess-free for clinical testing.",
            "handle": "/products/wee-box",
            "image_url": "https://files.zymoresearch.com/product-images/wee_box_5760x5760.webp",
            "navigation_image": "https://files.zymoresearch.com/product-images/wee_box_5760x5760.webp",
            "generalIndex": 999,
            "tags": [
                "urine",
                "device"
            ],
            filters: []
        },
        "Urine Collection Cup": {
            "title": "Urine Collection Cup",
            "catalogNumbers": "D3062-1",
            "description": "Small and easy-to-use plastic urine collection cups for research labs collecting urine specimens.",
            "handle": "/collections/urine-collection/products/urine-collection-cup",
            "image_url": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D3062-1_Urine-Collection-Cup_1ddcf228-f40e-461a-9319-238eab6650ae.jpg?v=1628532367&width=200",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D3062-1_Urine-Collection-Cup_1ddcf228-f40e-461a-9319-238eab6650ae.jpg?v=1628532367&width=600",
            "generalIndex": 999,
            "tags": [
                "urine",
                "accessories",
                "device"
            ],
            filters: []
        },
        "Urine Conditioning Buffer": {
            "title": "Urine Conditioning Buffer",
            "catalogNumbers": "D3061-1-8, D3061-1-140",
            "description": "Urine Conditioning Buffer (UCB) is a urine DNA and RNA stabilizer enabling ambient temperature storage and transport. ",
            "handle": "/collections/urine-collection/products/urine-conditioning-buffer",
            "image_url": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D3061-1-140-UCB-Bottle-140ml.jpg?v=1628532358&width=200",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D3061-1-140-UCB-Bottle-140ml.jpg?v=1628532358&width=600",
            "generalIndex": 12,
            "tags": [
                "urine",
                "reagent"
            ],
            filters: []
        },
        "DNA/RNA Shield DirectDetect": {
            "title": "DNA/RNA Shield DirectDetect",
            "catalogNumbers": "R1400, R1401-1, R1400-E, R1401-1-E",
            "description": "A sample collection/transport reagent/device that allows direct RT-PCR analysis without the need for nucleic acid extraction. Nucleic acids are preserved at ambient temperature upon collection. ",
            "handle": "/products/dna-rna-shield-directdetect",
            "image_url": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R1400-E_DNA-RNA-Shield-DirectDetect.jpg?v=1642712703&width=200",
            "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R1400-E_DNA-RNA-Shield-DirectDetect.jpg?v=1642712703&width=600",
            "generalIndex": 13,
            "tags": [
                "ce-ivd-certified",
                "1-ml",
                "reagent"
            ],
            filters: []
        },
        "Wastewater Sample Collection Bottle": {
            "title": "Wastewater Sample Collection Bottle",
            "catalogNumbers": "R1503, R1503-8",
            "description": "The Wastewater Sample Collection Bottles are designed as an all-in-one solution for safely collecting, transporting, and storing wastewater samples.",
            "handle": "/products/wastewater-sample-collection-bottle",
            "image_url": "https://files.zymoresearch.com/images/filter_page/sample_collection/d1503.webp",
            "navigation_image": "https://files.zymoresearch.com/images/filter_page/sample_collection/d1503.webp",
            "generalIndex": 15,
            "tags": [
                "water",
                "device",
                "environmental-vector"
            ],
            filters: []
        },
        "Green DNA/RNA Dry Transport": {
            "title": "Green DNA/RNA Dry Transport",
            "catalogNumbers": "R1141",
            "description": "Green DNA/RNA Dry Transport stabilizes NGS libraries for room temperature transportation with any carrier—no declarations needed.",
            "handle": "/products/green-dna-rna-dry-transport",
            "image_url": "https://www.zymoresearch.com/cdn/shop/files/green-dna-rna-dry-transport_600x.webp?v=1745352863",
            "navigation_image": "https://www.zymoresearch.com/cdn/shop/files/green-dna-rna-dry-transport_600x.webp?v=1745352863",
            "generalIndex": 15,
            "tags": [
                "ngs-library",
                "device",
            ],
            filters: []
        }
    }
}